import Page from 'components/Page';
import React from 'react';
import {Button, ButtonGroup, Card, CardBody, CardHeader, Col, Row, Table,} from 'reactstrap';
import BasePage from './BasePage';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {cloneObject, deleteParam, isEmpty, parseDate} from '../utils/Utilities';
import {MdDelete, MdEdit} from 'react-icons/md';
import {FaClone} from 'react-icons/fa';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import SearchInput from '../components/SearchInput';
import label from 'enqc-utilities/src/label/Label'

import FormBuilderCopyModal from "../components/modal/FormBuilderCopyModal";
import {delegateObjectsForSelection, navigate} from "enqc-utilities/src/utils/Utilities";
import DropdownInput from "../components/form/DropdownInput";
import {TYPE_INSPECTION, TYPE_RELEASE_VERIFICATION} from "enqc-utilities/src/utils/Global";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";


class FormBuilderPage extends BasePage{
  constructor(props) {
    super(props);
    this.state = {
      groupForms : [],
      groupForm:{},
      type:undefined,
      search:'',
      heading:{},
      modalAddConfirm:false,
      modalDeleteConfirm:false,
      modal: false,
      ascending:false,
      sortir:'created',
      page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
      totalPage:0,
      totalElement:0,
      pageElement:0,
      formCopyModal:false,
    }
  }

  componentWillReceiveProps(props, nextContext) {
    if(props!=this.props){
      this.setState({
        page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
      }, () => {
        this.fetchAll()
      })
    }
  }


  componentDidMount() {
    super.componentDidMount();
    this.fetchAll()
  }

  confirmSave = () =>{
    let groupForm = this.state.groupForm
    if(isEmpty(groupForm.name) || isEmpty(groupForm.heading)){
      this.showDialog("Notice", "Please complete this form fields")
    }else{
      this.setState({
        modalAddConfirm:true
      })
    }
  }

  save = () => {
    let {groupForm} = this.state
    if(!groupForm.id && !groupForm.active){
      groupForm.active = false ;
    }

    this.setState({
      modalAddConfirm:false
    }, () => {
      this.post(Global.API.GROUP_FORM_SAVE, groupForm, null, res => {
        if(res.code===200){
          this.setState({
            groupForm:{}
          }, () => {
            this.fetchAll()
          })
        }
      }, true, true);
    })
  }

  confirmDelete = () =>{
    this.setState({
      modalDeleteConfirm:true
    })
  }

  delete = () => {
    let {groupForm} = this.state
    if(!groupForm.id){
      return
    }
    this.setState({
      modalDeleteConfirm:false
    }, () => {
      this.get(Global.API.GROUP_FORM_DELETE+"/"+groupForm.id, null, null, res => {
        if(res.code===200){
          this.setState({
            groupForm:{}
          }, () => {
            this.fetchAll()
          })
        }
      },true, true);
    })
  }

  closeDialog = () =>{
    this.setState({
      modalAddConfirm:false,
      modalDeleteConfirm:false
    })
  }

  fetchAll = () => {
    let {ascending, sortir, page, type, search} = this.state
    this.get(Global.API.GROUP_FORMS, {
      params:{
        search:search,
        type:type,
        page: page-1,
        ascending:ascending,
        sortir:sortir,
      }
    }, null, response=>{
      if(response.code === 200){
        this.setState({
          groupForms : response.data,
          totalPage: response.totalPage,
          totalElement: response.totalElement,
          pageElement: response.pageElement,

        })
      }
    }, true, true);
  }

  cloneForm = (groupForm, name, documentNumber, type) => {
    let form = new FormData()
    form.append("groupFormId", groupForm.id)
    form.append("name", name)
    form.append("documentNumber", documentNumber)
    form.append("type", type)
    this.post(Global.API.CLONE_GROUP_FORM, form, null, response=>{
      if(response.code === 200){
        this.fetchAll()
      }
    }, true, true);
  }


  refresh = (ascending, sortir) => (
      this.setState({
        ascending:ascending,
        sortir:sortir
      }, () => {
        this.fetchAll()
      })
  )


  render() {
    let {formCopyModal, groupForm, modalAddConfirm, modalDeleteConfirm, ascending, sortir, page, totalPage, pageElement} = this.state
    let orderOptions = delegateObjectsForSelection({name:label.Name, field:'name'}, {name:label.DocumentNumber, field:'documentNumber'}, {name:label.Created, field:'created'}, {name:label.Updated, field:'updated'})
    let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})
    let formTypeObjects = delegateObjectsForSelection({name:TYPE_INSPECTION, field:TYPE_INSPECTION}, {name:TYPE_RELEASE_VERIFICATION, field:TYPE_RELEASE_VERIFICATION})

    return (
        <Page
            title={label.GroupForm}
            breadcrumbs={[{ name: label.GroupForm, active: true }]}
            className="TablePage">
          {super.render()}
          <FormBuilderCopyModal
              groupForm={groupForm}
              okCallback={(groupForm, formName, documentNumber, type)=>{
                this.cloneForm(groupForm, formName, documentNumber, type)
                this.setState({
                  formCopyModal:false
                })
              }}
              closeCallback={()=>{
                this.setState({
                  formCopyModal:false
                })
              }}
              modal={formCopyModal}
          />
          <ConfirmDialog
              showing={modalAddConfirm}
              title={label.UpdateConfirmation}
              message="Do you want to udpate this groupForm item to your list ?"
              okCallback={this.save}
              cancelCallback={this.closeDialog}/>
          <ConfirmDialog
              showing={modalDeleteConfirm}
              title={label.DeleteConfirmationTitle}
              message="Do you want to delete this groupForm item from your list ?"
              okCallback={this.delete}
              cancelCallback={this.closeDialog}/>
          <Row key={1}>
            <Col>
              <Card>
                <PrimaryCardHeader content={label.GroupFormList}/>
                <CardBody >
                  <Row>
                    <Col>
                      <Card body>
                        <Row>
                          <Col md={4} className="text-left mb-4">
                            <ButtonGroup>
                              <Button color="primary" onClick={e=>{
                                navigate(this.props, '/formBuilderDetail');
                              }}> + {label.AddFormBuilder}</Button>
                            </ButtonGroup>
                          </Col>
                          <Col md={3} className="text-right mb-4">
                            <ButtonGroup className="d-flex float-right">
                              <DropdownInput
                                  title={label.SortBy}
                                  options={orderOptions}
                                  onSelect={(item) => {
                                    this.refresh(ascending, item.field)
                                  }}
                                  onReset={() => {
                                    this.refresh(ascending, "created")
                                  }}/>
                              &nbsp;&nbsp;&nbsp;
                              <DropdownInput
                                  options={ascendingOptions}
                                  onSelect={(item) => {
                                    this.refresh(item.field, sortir)
                                  }}
                                  onReset={() => {
                                    this.refresh(true, sortir)
                                  }}/>
                              &nbsp;&nbsp;&nbsp;
                              <DropdownInput
                                  title={label.FormType}
                                  options={formTypeObjects}
                                  onSelect={(item) => {
                                    this.setState({type:item.field}, () => {
                                      this.refresh(ascending, sortir)
                                    })
                                  }}
                                  onReset={() => {
                                    this.setState({type:undefined}, () => {
                                      this.refresh(ascending, sortir)
                                    })
                                  }}/>
                            </ButtonGroup>
                          </Col>
                          <Col md={5} className="text-left mb-4">
                            <SearchInput
                                placeholder={label.Search}
                                value={this.state.search}
                                onChange={e=>{
                                  this.setState({
                                    search:e.target.value
                                  }, () => {
                                    if(this.state.search===''){
                                      deleteParam(this.props, 'page')
                                    }
                                  })
                                }}
                                onEnter={e=>{
                                  if(this.state.search!==''){
                                    deleteParam(this.props, 'page')
                                  }
                                }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Table responsive hover>
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>{label.Name}</th>
                                <th>{label.DocumentNumber}</th>
                                <th>{label.Type}</th>
                                <th>{label.Created}</th>
                                <th>{label.Updated}</th>
                                <th>{label.Delete}&nbsp;|&nbsp;{label.Copy}&nbsp;|&nbsp;{label.Edit}</th>
                              </tr>
                              </thead>
                              <tbody>
                              {
                                this.state.groupForms.map((item, index) =>(
                                    <tr key={index}>
                                      <th scope="row">
                                        {((page-1)* pageElement)+(++index)}
                                      </th>
                                      <td>{item.name}</td>
                                      <td>{item.documentNumber}</td>
                                      <td>{item.type}</td>
                                      <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                      <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                      <td>
                                        <Button color="danger" onClick={e => {
                                          this.setState({
                                            groupForm:cloneObject(item)
                                          }, () => {
                                            this.confirmDelete()
                                          })
                                        }}>
                                          <MdDelete/>
                                        </Button>
                                        &nbsp;
                                        <Button color="warning" onClick={e => {
                                          this.setState({
                                            groupForm:cloneObject(item)
                                          }, () => {
                                            this.setState({formCopyModal: true})
                                          })
                                        }}>
                                          <FaClone/>
                                        </Button>
                                        &nbsp;
                                        <Button color="primary" onClick={e=>{
                                          this.props.history.push('/formBuilderDetail?id='+item.id)
                                        }}>
                                          <MdEdit/>
                                        </Button>
                                      </td>
                                    </tr>
                                ))
                              }
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
                <Pagination {...this.props} currentPage={parseInt(page)} pageCount={totalPage} />
              </Card>
            </Col>
          </Row>
        </Page>
    );
  }
}

export default Object.assign(FormBuilderPage, {ENDPOINT : "/formBuilders"})
